import QuillEditor from './quill/QuillEditor';
import { Controller } from 'react-hook-form';



function ControlledWYSIWYG({control, name, label, errors, className, initialContent, style, articleId}) {
   const useClasses = className ? className : "items-center mb-10";

   return (
	<Controller
      className={useClasses}
      render={({ field: { onChange, value, ...field } }) =>
          <QuillEditor initialContent={initialContent}
                       style={style}
                       articleId={articleId}
                       onChange={onChange}
                       value={value}
                       {...field} />}
      name={name}
      control={control}
    /> 
   );
}

export default ControlledWYSIWYG;
